import { React } from "react";
import { Container } from "react-bootstrap";
import AboutPage from "../../pages/about/AboutPage";
import { AboutUsSponsors } from "../../pages/about/AboutUsData/AboutUsData";
import ScrollTop from "./ScrollTop";

const AboutUs = () => {
  const sponsors = AboutUsSponsors;
  const imgDim = { width: "100%", height: "100%" };

  return (
    <>
      <Container id="#about" fluid className="my-3 mb-5">
        <hr className="mx-auto mt-5 mt-lg-0" />
        <div className="row gap-0 my-4">
          {sponsors.map((sponsor) => {
            return (
              <div
                className="col text-center align-items-center mb-2 mb-lg-0"
                style={{ maxHeight: "3.7rem" }}
                key={sponsor.id}
              >
                <img src={sponsor.img} alt="sponsorImage" style={imgDim} />
              </div>
            );
          })}
        </div>
        <hr className="mx-auto" />
      </Container>

      <AboutPage />
      <ScrollTop />
    </>
  );
};

export default AboutUs;
